/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReferralSubmissionResponse
 */
export interface CreateReferralSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateReferralSubmissionResponse
     */
    submissionId: string;
}

/**
 * Check if a given object implements the CreateReferralSubmissionResponse interface.
 */
export function instanceOfCreateReferralSubmissionResponse(value: object): value is CreateReferralSubmissionResponse {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function CreateReferralSubmissionResponseFromJSON(json: any): CreateReferralSubmissionResponse {
    return CreateReferralSubmissionResponseFromJSONTyped(json, false);
}

export function CreateReferralSubmissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralSubmissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submissionId'],
    };
}

export function CreateReferralSubmissionResponseToJSON(value?: CreateReferralSubmissionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'submissionId': value['submissionId'],
    };
}

